var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRegalo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50px",
    height: "50px",
    viewBox: "0 0 50 50",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0L50 0L50 50L0 50L0 0Z",
    id: "path_1"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "mask_1"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path_1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "regalo"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0L50 0L50 50L0 50L0 0Z",
    id: "Background",
    fill: "#FFFFFF",
    fillOpacity: 0,
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#mask_1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0 1.5933838)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.875 12.4387L36.9875 12.4387C37.6969 11.9543 38.3063 11.473 38.7313 11.0418C41.25 8.50742 41.25 4.38242 38.7313 1.84805C36.2844 -0.614453 32.0156 -0.617578 29.5656 1.84805C28.2125 3.20742 24.6156 8.7418 25.1125 12.4387L24.8875 12.4387C25.3813 8.7418 21.7875 3.20742 20.4344 1.84805C17.9844 -0.617578 13.7156 -0.614453 11.2688 1.84805C8.75 4.38242 8.75 8.50742 11.2656 11.0418C11.6938 11.473 12.3031 11.9543 13.0125 12.4387L3.125 12.4387C1.40313 12.4387 0 13.8418 0 15.5637L0 23.3762C0 24.2387 0.7 24.9387 1.5625 24.9387L3.125 24.9387L3.125 43.6887C3.125 45.4105 4.52812 46.8137 6.25 46.8137L43.75 46.8137C45.4719 46.8137 46.875 45.4105 46.875 43.6887L46.875 24.9387L48.4375 24.9387C49.3 24.9387 50 24.2387 50 23.3762L50 15.5637C50 13.8418 48.5969 12.4387 46.875 12.4387L46.875 12.4387ZM13.485 4.0511C14.1193 3.4136 14.96 3.0636 15.8537 3.0636C16.7443 3.0636 17.585 3.4136 18.2193 4.0511C20.3256 6.16985 22.4193 11.5823 21.6912 12.3355C21.6912 12.3355 21.56 12.4386 21.1131 12.4386C18.9537 12.4386 14.8318 10.1948 13.485 8.8386C12.1756 7.51985 12.1756 5.36985 13.485 4.0511L13.485 4.0511ZM23.4375 43.6886L6.25 43.6886L6.25 24.9386L23.4375 24.9386L23.4375 43.6886L23.4375 43.6886ZM23.4375 21.8136L3.125 21.8136L3.125 15.5636L21.1125 15.5636L23.4375 15.5636L23.4375 21.8136L23.4375 21.8136ZM31.7812 4.05125C33.0499 2.77937 35.2499 2.7825 36.5155 4.05125C37.8249 5.37 37.8249 7.51999 36.5155 8.83875C35.1687 10.195 31.0468 12.4387 28.8874 12.4387C28.4405 12.4387 28.3093 12.3387 28.3062 12.3356C27.5812 11.5825 29.6749 6.17 31.7812 4.05125L31.7812 4.05125ZM43.75 43.6886L26.5625 43.6886L26.5625 24.9386L43.75 24.9386L43.75 43.6886L43.75 43.6886ZM46.875 21.8136L26.5625 21.8136L26.5625 15.5636L28.8875 15.5636L46.875 15.5636L46.875 21.8136L46.875 21.8136Z",
    id: "Shape",
    fill: "#304278",
    fillRule: "evenodd",
    stroke: "none"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegalo);
export default __webpack_public_path__ + "static/media/regalo.3bc1f68932c1f1474b0bb591c30096ce.svg";
export { ForwardRef as ReactComponent };